import { Color, FormItem, Input, NumberFormat, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentTitle } from '@features/invoices/utils/getInvoiceDocumentTitle'
import { getInvoiceNumberDisplayedValue } from '@features/invoices/utils/getInvoiceNumberDisplayedValue'
import { getInvoiceSummaryTotals } from '@features/invoices/utils/getInvoiceSummaryTotals'
import { useGetZervantDocumentSettings } from '@features/invoicingSettings/hooks/useGetZervantDocumentSettings'

import { useInvoiceEditorForm } from '../../../../../../../../../../../../contexts/invoiceEditorFormContext'

export const EmailSubject = (): ReactElement => {
  const { t } = useTranslation()
  const { getInvoiceLocale } = useGetZervantDocumentSettings(InvoiceDocumentType.Invoice)

  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { watch } = invoiceEditorForm
  const [currency, invoiceNumber, invoicePrefix, invoiceLines, invoiceLanguage] = watch([
    'currency',
    'invoiceNumber',
    'invoiceNumberPrefix',
    'invoiceLines',
    'language',
  ])
  const locale = getInvoiceLocale()
  const { grossTotal } = getInvoiceSummaryTotals({ currency, invoiceLines })
  const displayedTotalAmount = NumberFormat.getCurrencyNumber(grossTotal, currency, locale)

  const displayedInvoiceNumber = getInvoiceNumberDisplayedValue(invoiceNumber, invoicePrefix)
  const displayedTitle = getInvoiceDocumentTitle({
    documentType: InvoiceDocumentType.Invoice,
    language: invoiceLanguage,
    t,
  })

  const subject = [`${displayedTitle} ${displayedInvoiceNumber}`, displayedTotalAmount].join(' - ')

  return (
    <FormItem
      label={t('external_invoices.editor.form.recurring_invoice_settings.email_template.modal.field.subject.label')}
    >
      <Input disabled value={subject} size="sm" />
      <Text color={Color.Grey700} inline variant="bodySM">
        {t('external_invoices.editor.form.recurring_invoice_settings.email_template.modal.field.subject.disclaimer')}
      </Text>
    </FormItem>
  )
}
